import type { ReactNode } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { SeoRuntime } from '@/components/seo/SeoRuntime';
import { useStore } from '@/context/StoreContext';
import { navigate } from '@/hooks/useRoute';
export function SiteLayout({children}:{children:ReactNode}){const {compare,clearCompare}=useStore();return <><SeoRuntime/><Header/><main id="main">{children}</main><Footer/>{compare.length>0&&<div className="compare-bar"><span>{compare.length} תכשיטים להשוואה</span><a href="/compare" onClick={e=>{e.preventDefault();navigate('/compare')}}>לצפייה</a><button onClick={clearCompare}>ניקוי</button></div>}</>}
